import "../styles/home.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import MertPhoto from "../assets/images/MertFoto.jpg";
import astroPhoto from "../assets/images/astro.webp";
import { Helmet } from "react-helmet";
import MobileTopTabs from "../components/MobileTopTabs";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Mert Arinci | Full-Stack developer</title>
        <meta
          name="description"
          content="Mert Arinci - Full-Stack Developer specializing in JavaScript, React, Node.js. Based in Rotterdam, Netherlands."
        />
        <meta
          name="keywords"
          content="Mert Arinci, Full-Stack Developer, JavaScript, React, Node.js, Rotterdam, Netherlands, Web Developer, Frontend, Backend"
        />
        <link rel="canonical" href="https://arinci.nl/" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Mert Arinci | Full-Stack Developer"
        />
        <meta
          property="og:description"
          content="Full-Stack Developer specializing in JavaScript, React, Node.js. Based in Rotterdam, Netherlands."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://arinci.nl/" />
        <meta property="og:site_name" content="Mert Arinci Portfolio" />
        <meta property="og:image" content="https://arinci.nl/og-image.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Mert Arinci | Full-Stack Developer"
        />
        <meta
          name="twitter:description"
          content="Full-Stack Developer specializing in JavaScript, React, Node.js. Based in Rotterdam, Netherlands."
        />
        <meta name="twitter:image" content="https://arinci.nl/og-image.jpg" />

        {/* Additional SEO Tags */}
        <meta name="author" content="Mert Arinci" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="geo.region" content="NL-ZH" />
        <meta name="geo.placename" content="Rotterdam" />
        <meta name="geo.position" content="51.9244;4.4777" />
        <meta name="ICBM" content="51.9244, 4.4777" />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",
            name: "Mert Arinci",
            jobTitle: "Full-Stack Developer",
            description:
              "Full-Stack Developer specializing in JavaScript, React, Node.js",
            url: "https://arinci.nl",
            email: "mertarinci96@gmail.com",
            telephone: "+31616150171",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Rotterdam",
              addressCountry: "Netherlands",
            },
            sameAs: [
              "https://linkedin.com/in/mert-arinci-7536ab26a/",
              "https://github.com/mertarinci",
            ],
            knowsAbout: [
              "JavaScript",
              "React",
              "Node.js",
              "TypeScript",
              "HTML",
              "CSS",
              "MongoDB",
              "SQL",
              "Python",
              "Express",
              "Next.js",
            ],
          })}
        </script>
      </Helmet>
      <div id="homepage">
        <Navbar activePage={"home"} />

        <div className="home-content">
          <div className="left">
            <p className="subheader">Hi all, I am</p>
            <h1 className="main-header">Mert Arinci</h1>
            <p className="function-header">{">"} Full Stack Developer</p>

            <div className="personal-info">
              <p className="mobile-warning">
                <span className="purple-text">const</span>{" "}
                <span className="light-header-text">importantNote</span> ={" "}
                <span className="string-color-text">
                  "Please check out my website on a desktop or laptop for the
                  best experience."
                </span>
              </p>
              <div className="info-line">
                <span className="gray-text">// contact</span>
                <p className="code-line">
                  <span className="purple-text">const</span>{" "}
                  <span className="light-header-text">phoneNumber</span> ={" "}
                  <a href="tel:+31616150171" className="number-color-text">
                    616 15 01 71
                  </a>
                  ;
                </p>
                <p className="code-line">
                  <span className="purple-text">const</span>{" "}
                  <span className="light-header-text">email</span> ={" "}
                  <a
                    href="mailto:mertarinci96@gmail.com"
                    className="string-color-text"
                  >
                    "mertarinci96@gmail.com"
                  </a>
                  ;
                </p>
                <p className="code-line">
                  <span className="purple-text">const</span>{" "}
                  <span className="light-header-text">githubProfile</span> ={" "}
                  <a
                    href="https://github.com/mertarinci"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="string-color-text"
                  >
                    "github.com/mertarinci"
                  </a>
                  ;
                </p>
                <p className="code-line">
                  <span className="purple-text">const</span>{" "}
                  <span className="light-header-text">linkedInProfile</span> ={" "}
                  <a
                    href="https://linkedin.com/in/mert-arinci-7536ab26a/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="string-color-text"
                  >
                    "linkedin.com/in/mert-arinci-7536ab26a"
                  </a>
                  ;
                </p>
              </div>
              <div className="info-line">
                <span className="gray-text">// about me</span>
                <p className="code-line">
                  <span className="purple-text">const </span>{" "}
                  <span className="light-header-text">age</span> ={" "}
                  <span className="number-color-text">29</span>;
                </p>
                <p className="code-line">
                  <span className="purple-text">const</span>{" "}
                  <span className="light-header-text">location</span> ={" "}
                  <span className="string-color-text">
                    "Rotterdam, the Netherlands"
                  </span>
                  ;
                </p>
                <p className="code-line">
                  <span className="purple-text">const</span>{" "}
                  <span className="light-header-text">lovesCoding</span> ={" "}
                  <span className="true-color-text">true</span>;
                </p>
                {/* <p className="code-line">
                <span className="purple-text">const</span>{" "}
                <span className="light-header-text">availableForWork</span> ={" "}
                <span className="true-color-text">true</span>;
              </p> */}
              </div>
              <div className="info-line">
                <span className="gray-text">// my skills</span>
                <p className="code-line">
                  <span className="purple-text">const</span>{" "}
                  <span className="light-header-text">skills</span> ={" "}
                  <span className="string-color-text">
                    <span className="bracket">{"["}</span>
                    "JavaScript", "React", "TypeScript", "HTML", <br /> "CSS",
                    "Node.js", "Next.js" "Express", "MongoDB", "SQL", "Python",{" "}
                    <br />
                    "SEO", "Git", "Agile", "Scrum", "Docker", "AWS", "Firebase"
                    <span className="bracket">{"]"}</span>
                  </span>
                  ;
                </p>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="background-blur"></div>
            <img className="astro-image" src={astroPhoto} alt="astronaut" />
          </div>
        </div>
        <MobileTopTabs />
        <Footer />
      </div>
    </>
  );
};

export default Home;
